import axios from 'axios';
import router from "../router";

const axiosInstance = axios.create({
    // baseURL: 'https://airbox.edison.ge',
    // baseURL: 'http://localhost:8000',
});

export default {
    install(Vue) {
        Vue.prototype.$axios = axiosInstance;

        Vue.prototype.$axios.interceptors.response.use(function (config) {
            return config;
        }, function (error) {
            if (error.response.status === 401) {
                Vue.prototype.$user.logout();
                return router.push({name: 'login'});
            }
            return Promise.reject(error)
        });
    },
};

export {axiosInstance};

